import React, { Fragment, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const Loading = () => {
  const loading = useSelector((state) => state.loading.showLoading)
  return (
    <Fragment>
      {loading && (
        <div>
          <Spinner
            animation="border"
            variant="info"
            className="position-fixed"
            size="xxl"
            style={{
              zIndex: 10000,
              left: '15%',
              right: 0,
              top: '20%',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: 100,
              height: 100,
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              backgroundColor: '#343a4038',
              zIndex: 9999,
            }}
          ></div>
        </div>
      )}
    </Fragment>
  )
}

export default Loading
